
/**
 * @export
 * @enum {string}
 */
export enum AlertSortField {
    ALERT_NAME = 'ALERT_NAME',
    GENERAL_ALERT_TYPE = 'GENERAL_ALERT_TYPE',
    SEARCH_LIST_TYPE = 'SEARCH_LIST_TYPE',
    FREQUENCY = 'FREQUENCY'
}